import type { Build } from '@todesktop/shared';

const PLATFORMS = ['linux', 'mac', 'windows'] as const;

// X build has failed, should we exit? I.e. is it settled?
export default function shouldExitOnBuildFailure(build: Build): boolean {
  const hasBuildSettled = PLATFORMS.every(
    (platform) =>
      build[platform]!.shouldSkip ||
      'succeeded' === build[platform]!.status ||
      ('failed' === build[platform]!.status &&
        build[platform]!.numberOfAttemptedBuilds === 2),
  );

  const hasSettledWithError = PLATFORMS.some(
    (platform) => 'failed' === build[platform]!.status,
  );

  return hasBuildSettled && hasSettledWithError;
}
